<template>
  <div class="filter-overview">
    <quote-overview-search :model-value="searchQuery" @on-search="onSearch" />
    <quote-overview-status-filter
      :model-value="statusFilter"
      @on-update-status-filter="onUpdateStatusFilter"
    />
    <div class="filter-toggles">
      <form-toggle
        id="filter-establishments"
        :value="showQuotesAcrossEstablishments"
        :title="i18n.t('/Dashboard/Quotes/Include All Establishments')"
        @change="onEstablishmentsToggle"
      />
      <form-toggle
        id="filter-colleagues"
        :value="showColleagueQuotes"
        :title="i18n.t('/Dashboard/Quotes/Include Colleagues')"
        @change="onColleagueToggle"
      />
    </div>
  </div>
</template>

<script>
import QuoteOverviewSearch from '@/components/generic/presentational/organisms/quoteOverview/QuoteOverviewSearch.vue'
import QuoteOverviewStatusFilter from '@/components/generic/presentational/organisms/quoteOverview/QuoteOverviewStatusFilter.vue'
import FormToggle from '@/components/generic/presentational/atoms/formCheckbox/FormToggle.vue'
import { mapState } from 'vuex'

export default {
  components: {
    QuoteOverviewSearch,
    QuoteOverviewStatusFilter,
    FormToggle,
  },
  emits: ['update'],
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  computed: mapState('quotes', {
    showQuotesAcrossEstablishments: (state) => state.showQuotesAcrossEstablishments,
    showColleagueQuotes: (state) => state.showColleagueQuotes,
    searchQuery: (state) => state.searchQuery,
    statusFilter: (state) => state.statusFilter,
  }),
  methods: {
    async onSearch(query) {
      this.$store.commit('quotes/setFilterSearchQuery', query)
      await this.update()
    },
    async onUpdateStatusFilter(statusFilter) {
      this.$store.commit('quotes/setFilterStatus', statusFilter)
      await this.update()
    },
    async onColleagueToggle(showColleageQuotes) {
      this.$store.commit('quotes/setFilterColleagueQuotes', showColleageQuotes)
      await this.update()
    },
    async onEstablishmentsToggle(showAll) {
      this.$store.commit('quotes/setFilterAllEstablishments', showAll)
      await this.update()
    },
    async update() {
      this.$emit('update')
    },
  },
}
</script>

<style></style>
